<template>
  <div>
    <section>
      <b-row>
        <b-col cols="12" md="4"
          ><b-form-input
            v-model="searchValue"
            @input="onSearch"
            placeholder="search..."
          ></b-form-input
        ></b-col>
        <b-col cols="6" md="6"> </b-col>
        <b-col v-if="is_add" cols="6" md="2">
          <b-button block @click="showSideBar = true" variant="primary"
            >Add Item</b-button
          ></b-col
        >
      </b-row>
    </section>
    <b-card no-body header-tag="header" footer-tag="footer">
      <b-card-text>
        <b-table
          bordered
          responsive
          :fields="fields"
          :items="items"
          :busy="isBusy"
          outlined
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(sr)="data">
            {{
              data.index + 1 + (pagination.currentPage - 1) * pagination.limit
            }}
          </template>

          <template #cell(item_image)="data">
            <b-img
              width="100"
              height="100"
              thumbnail
              :src="data.item.item_image ? BASE_URL + data.item.item_image : ''"
              alt=""
            ></b-img>
          </template>

          <template #cell(item_is_active)="data">
            {{ data.item.item_is_active == "Y" ? "Active" : "Disabled" }}
          </template>

          <template v-if="is_update" #cell(action)="data">
            <b-button
              @click="onEditItem(data.item)"
              size="sm"
              variant="outline-primary"
              >Edit</b-button
            >
          </template>
        </b-table>
      </b-card-text>
      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-end justify-content-end justify-content-sm-center"
            >
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.limit"
                @change="onChange"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card>
    <!-- no-close-on-esc
      no-close-on-backdrop -->
    <b-sidebar
      right
      v-model="showSideBar"
      id="sidebar-backdrop"
      title="Items"
      backdrop-variant="dark"
      backdrop
      shadow
    >
      <div class="px-2 py-1">
        <b-form-group label=" Name">
          <b-form-input
            v-model="form.item_name"
            placeholder="Item Name"
            id="input-default-name"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Category">
          <v-select
            v-model="form.item_category_id"
            placeholder="Select Category"
            label="category_name"
            value="category_id"
            :reduce="(cat) => cat.category_id"
            :options="categoryListArray"
          />
        </b-form-group>
        <b-form-group label=" Unique Code">
          <b-form-input
            v-model="form.item_unique_code"
            placeholder="Item Unique Code"
            id="input-default-code"
          ></b-form-input>
        </b-form-group>

        <b-form-group label=" Price">
          <b-form-input
            type="number"
            v-model="form.item_price"
            placeholder="Item Price"
            id="input-default-price"
          ></b-form-input>
        </b-form-group>
        <b-form-group label=" Minimum Order">
          <b-form-input
            type="number"
            v-model="form.item_min_quantity"
            placeholder="Item Minimum Order"
            id="input-default-order"
          ></b-form-input>
        </b-form-group>
        <b-form-group label=" Maximum Order">
          <b-form-input
            type="number"
            v-model="form.item_max_quantity"
            placeholder="Item Maximum Order"
            id="input-default-maxorder"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Total Quantity">
          <b-form-input
            type="number"
            v-model="form.item_total_quantity"
            placeholder="Total Quantity"
            id="input-default-totalquantity"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Description">
          <b-form-textarea
            v-model="form.item_short_description"
            placeholder="Description"
            id="input-default-description"
          ></b-form-textarea>
        </b-form-group>

        <b-card-group class="m-1" deck>
          <b-card
            border-variant="primary"
            :img-src="form.item_image ? BASE_URL + form.item_image : ''"
            img-alt=" Small image"
            img-bottom
          >
            <b-card-text>
              <b-form-group label="Image">
                <b-form-file
                  @input="onFileUpload(item_upload_model)"
                  v-model="item_upload_model"
                  plain
                ></b-form-file>
              </b-form-group>
            </b-card-text>
          </b-card>
        </b-card-group>

        <b-form-group label="Item Status">
          <b-form-checkbox v-model="form.item_is_active" switch>{{
            form.item_is_active == true ? "Active" : "Disabled"
          }}</b-form-checkbox>
        </b-form-group>
        <b-button block variant="primary" @click="onSubmit">Submit</b-button>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import {
  AddUpdateItemService,
  GetItemListService,
  GetCategoryListService,
} from "@/apiServices/MasterServices";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { UserService } from "@/apiServices/storageService";
import axios from "axios";
import vSelect from "vue-select";
export default {
  data() {
    return {
      form: {
        item_id: null,
        item_name: null,
        item_unique_code: null,
        item_short_description: null,
        item_long_description: null,
        item_price: null,
        item_category_id: null,
        item_min_quantity: null,
        item_max_quantity: null,
        item_total_quantity: null,
        item_image: null,
        item_order: null,
        item_is_active: true,
      },
      categoryListArray: [],
      BASE_URL: process.env.VUE_APP_BASEURL,
      loading: false,
      item_upload_model: null,
      searchValue: null,
      showSideBar: false,
      isBusy: false,
      optionsPermission: [
        { text: "Read", value: "read" },
        { text: "Add", value: "create" },
        { text: "Update", value: "update" },
      ],

      fields: [
        {
          key: "sr",
          label: "SR",
        },
        {
          key: "item_name",
          label: "Item Name",
          sortable: true,
        },
        {
          key: "item_unique_code",
          label: "Item Code",
          sortable: true,
        },
        {
          key: "item_image",
          label: "Item Image",
          sortable: true,
        },
        {
          key: "item_price",
          label: "Item Price",
          sortable: true,
        },
        {
          key: "item_is_active",
          label: "Item Status",
          sortable: true,
        },
        {
          key: "action",
          label: "",
        },
      ],
      items: [],
      pagination: {
        currentPage: 1,
        limit: 10,
        totalRows: 0,
      },
      debounce: null,
    };
  },
  computed: {
    is_add() {
      let permissionData = UserService.getUserPermissions();
      let obj = permissionData.find((o) => o.subject == this.$route.name);
      if (obj) {
        let objP = obj.permission.find((p) => p == "create");
        if (objP) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    is_update() {
      let permissionData = UserService.getUserPermissions();
      let obj = permissionData.find((o) => o.subject == this.$route.name);
      if (obj) {
        let objP = obj.permission.find((p) => p == "update");
        if (objP) {
          return true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    is_read() {
      let permissionData = UserService.getUserPermissions();
      let obj = permissionData.find((o) => o.subject == this.$route.name);
      if (obj) {
        let objP = obj.permission.find((p) => p == "read");
        if (objP) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  components: {
    vSelect,
  },
  beforeMount() {
    this.getItemList();
    this.getCategoryList();
  },
  methods: {
    async onSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getItemList();
      }, 1000);
    },
    async onEditItem(item) {
      Object.keys(item).map((x) => {
        this.form[x] = item[x];

        if (x == "item_is_active") {
          this.form[x] = item[x] == "Y" ? true : false;
        }
      });

      this.showSideBar = true;
    },
    async getItemList() {
      try {
        this.isBusy = true;
        const response = await GetItemListService({
          limit: this.pagination.limit,
          currentPage: this.pagination.currentPage,
          search: this.searchValue,
          isMaster: "Y",
        });
        if (response.data.status) {
          this.items = response.data.Records.data;
          if (!isNaN(response.data.Records.pagination.total)) {
            this.pagination.totalRows = response.data.Records.pagination.total;
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
      }
    },
    async onSubmit() {
      try {
        this.form.item_is_active = this.form.item_is_active == true ? "Y" : "N";
        const response = await AddUpdateItemService(this.form);
        if (response.data.status) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "primary",
            },
          });
          this.showSideBar = false;
          Object.keys(this.form).forEach((key) => {
            if (key === "item_is_active") {
              this.form[key] = true;
            } else {
              this.form[key] = null;
            }
          });
          this.getItemList();
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        console.log(error, "error");
      }
    },

    async getCategoryList() {
      try {
        this.isBusy = true;
        const response = await GetCategoryListService({
          limit: 500,
        });
        if (response.data.status) {
          this.categoryListArray = response.data.Records.data;
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
      }
    },
    onChange() {
      this.$nextTick(() => {
        this.getItemList();
      });
    },

    async onFileUpload(uploadVModelValue) {
      this.loading = true;
      try {
        const url = this.BASE_URL + "/admin/uploadimage";
        const formData = new FormData();
        formData.append("image", uploadVModelValue);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
            authorization: sessionStorage.getItem("access_token"),
            "x-access-token": sessionStorage.getItem("access_token"),
          },
        };
        const response = await axios.post(url, formData, config);
        if (response.data.message) {
          this.form.item_image = response.data.path;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log("Error in UploadFile ", err);
      }
    },
  },
};
</script>
